/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as MusicbrainzRouteImport } from './routes/musicbrainz'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StationNaddrRouteImport } from './routes/station.$naddr'
import { Route as ProfilePubkeyRouteImport } from './routes/profile.$pubkey'
import { Route as BrowseGenresRouteImport } from './routes/browse.genres'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const MusicbrainzRoute = MusicbrainzRouteImport.update({
  id: '/musicbrainz',
  path: '/musicbrainz',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StationNaddrRoute = StationNaddrRouteImport.update({
  id: '/station/$naddr',
  path: '/station/$naddr',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilePubkeyRoute = ProfilePubkeyRouteImport.update({
  id: '/profile/$pubkey',
  path: '/profile/$pubkey',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseGenresRoute = BrowseGenresRouteImport.update({
  id: '/browse/genres',
  path: '/browse/genres',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/community': typeof CommunityRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/community': typeof CommunityRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/community': typeof CommunityRoute
  '/favorites': typeof FavoritesRoute
  '/musicbrainz': typeof MusicbrainzRoute
  '/settings': typeof SettingsRoute
  '/browse/genres': typeof BrowseGenresRoute
  '/profile/$pubkey': typeof ProfilePubkeyRoute
  '/station/$naddr': typeof StationNaddrRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/community'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/community'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  id:
    | '__root__'
    | '/'
    | '/community'
    | '/favorites'
    | '/musicbrainz'
    | '/settings'
    | '/browse/genres'
    | '/profile/$pubkey'
    | '/station/$naddr'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CommunityRoute: typeof CommunityRoute
  FavoritesRoute: typeof FavoritesRoute
  MusicbrainzRoute: typeof MusicbrainzRoute
  SettingsRoute: typeof SettingsRoute
  BrowseGenresRoute: typeof BrowseGenresRoute
  ProfilePubkeyRoute: typeof ProfilePubkeyRoute
  StationNaddrRoute: typeof StationNaddrRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/musicbrainz': {
      id: '/musicbrainz'
      path: '/musicbrainz'
      fullPath: '/musicbrainz'
      preLoaderRoute: typeof MusicbrainzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/station/$naddr': {
      id: '/station/$naddr'
      path: '/station/$naddr'
      fullPath: '/station/$naddr'
      preLoaderRoute: typeof StationNaddrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$pubkey': {
      id: '/profile/$pubkey'
      path: '/profile/$pubkey'
      fullPath: '/profile/$pubkey'
      preLoaderRoute: typeof ProfilePubkeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse/genres': {
      id: '/browse/genres'
      path: '/browse/genres'
      fullPath: '/browse/genres'
      preLoaderRoute: typeof BrowseGenresRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CommunityRoute: CommunityRoute,
  FavoritesRoute: FavoritesRoute,
  MusicbrainzRoute: MusicbrainzRoute,
  SettingsRoute: SettingsRoute,
  BrowseGenresRoute: BrowseGenresRoute,
  ProfilePubkeyRoute: ProfilePubkeyRoute,
  StationNaddrRoute: StationNaddrRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
